import { Link } from 'react-router-dom';
import { formatDistanceToNow } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import { ExternalLink, Calendar } from 'lucide-react';

export const PostCard = ({ post }) => {
  const publishedDate = new Date(post.published_at);

  return (
    <Link to={`/post/${post.post_id}`} data-testid={`post-card-${post.post_id}`}>
      <article
        className={`bg-white border rounded-lg overflow-hidden transition-all duration-300 hover:shadow-lg hover:-translate-y-1 cursor-pointer ${
          post.is_rss ? 'border-l-4 border-l-stone-300' : 'border-l-4 border-l-primary'
        }`}
      >
        {post.image_url && (
          <div className="aspect-[16/9] overflow-hidden bg-stone-100">
            <img
              src={post.image_url}
              alt={post.title}
              className="w-full h-full object-cover transition-transform duration-500 hover:scale-105"
              loading="lazy"
            />
          </div>
        )}

        <div className="p-6">
          {post.is_rss && post.source_name && (
            <div className="flex items-center gap-2 mb-3">
              <ExternalLink className="w-3 h-3 text-stone-500" strokeWidth={1.5} />
              <span className="text-xs text-stone-500 uppercase tracking-wider font-medium">
                {post.source_name}
              </span>
            </div>
          )}

          <h2 className="text-2xl font-heading font-semibold text-foreground mb-3 leading-tight">
            {post.title}
          </h2>

          <p className="text-base text-stone-700 leading-relaxed mb-4 line-clamp-3">
            {post.content.replace(/<[^>]*>/g, '')}
          </p>

          <div className="flex items-center justify-between pt-4 border-t border-stone-100">
            <div className="flex items-center gap-2 text-sm text-stone-500">
              <Calendar className="w-4 h-4" strokeWidth={1.5} />
              <time dateTime={post.published_at}>
                {formatDistanceToNow(publishedDate, {
                  addSuffix: true,
                  locale: ptBR
                })}
              </time>
            </div>

            {post.categories && post.categories.length > 0 && (
              <div className="flex gap-2">
                {post.categories.slice(0, 2).map((cat, idx) => (
                  <span
                    key={idx}
                    className="text-xs px-2 py-1 bg-stone-100 text-stone-600 rounded-md"
                  >
                    {cat}
                  </span>
                ))}
              </div>
            )}
          </div>
        </div>
      </article>
    </Link>
  );
};

export default PostCard;